<template>
    <div>
        <modal-template>
            <div slot="header">
                {{ trans('reporting.remind_user_modal.title') }}
            </div>

            <div slot="body">
                <div class="h:margin-bottom-3">
                    {{ this.trans('reporting.remind_user_modal.message', {user: user.email}) }}
                </div>

                <iframe :src="remindUserEmailSrc" class="mail-preview"></iframe>

                <div class="h:margin-bottom-3" v-html="this.trans('reporting.remind_user_modal.customization')"></div>

            </div>

            <div slot="footer">
                <div class="page-control h:margin-top-4">
                    <div class="page-control__element">
                        <button type="button" @click="$emit('close')"
                                class="btn btn--big btn--secondary h:margin-right-4">{{ trans('buttons.cancel') }}
                        </button>
                        <button type="button" @click="send"
                                class="btn btn--big btn--primary">{{ trans('buttons.send') }}
                        </button>
                    </div>
                </div>
            </div>
        </modal-template>
    </div>
</template>

<script>

export default {
    props: ['user'],

    data() {
        return {
            remindUserEmailSrc: `/api/reporting/${this.user.id}/get-remind-user-email`
        }
    },

    methods: {
        send() {
            axios
                .get('/api/reporting/' + this.user.id + '/reminduser')
                .then(response => {
                    this.$emit('close');
                    this.flash(response);
                })
                .catch((error) => {
                    this.flash({message: this.trans('reporting.flash.remind_user_failed'), level: 'warning'});
                });
        }
    }

}
</script>
